import React from 'react';
import {ContestPickType, ParlayType} from "../../constants/PickXEnums";
import {useDispatch, useSelector} from "react-redux";
import {setContestPick} from "../../stores/pickX/pickX.thunks";
import {removeContestPick} from "../../stores/pickX/pickX.slice";
import './ContestPickStatus.style.scss';
import {selectSelectedParlay} from "../../stores/pickX/pickX.selectors";

const ContestPickStatus = ({disableBtn, parlay, contest, showRemoveButton, isGameStarted}) => {

    const dispatch = useDispatch();
    const canPick = parlay?.parlayType !== ParlayType.UserParlay;
    const contestPick = parlay?.ContestsPicks[contest.Id];
    const selectedParlay = useSelector(selectSelectedParlay);

    const shouldHideUnderBtn = contest.SportId === 3 && contest.StatsKey != "TCP"

    const handleRemoveClick = ()=>{
        dispatch(removeContestPick({
            parlayId: parlay.Id,
            contestId: contest.Id,
        }));
    }

    const handlePickClick = (pick) => {
        dispatch(setContestPick({
            parlayId: parlay.Id,
            contestId: contest.Id,
            pick,
            removeIfSame: selectedParlay.parlayType === ParlayType.CreateYourOwn
        }));
    };

    const renderPickStatusIcon = () => {
        if(!isGameStarted && !canPick) {
            return <div className={`pickStatus notStarted`}/>
        }else if(!canPick) {
            return <div className={`pickResult _${contestPick.Result}`}/>
        }
    }

    if (!parlay)
        return null;

    return (
        <div className="ContestPickStatus">
            <button
                onClick={()=>handlePickClick(ContestPickType.Over)}
                disabled={disableBtn || !canPick}
                className={`arrowButton up ${disableBtn ? 'disabled' : ''} ${parlay.isContestPickSelected(contest.Id, ContestPickType.Over) ? 'selected gold-background' : ''}`}
            >
                <i className={'fa-solid fa-arrow-up'}/>
            </button>
            {!shouldHideUnderBtn && <button
                onClick={() => handlePickClick(ContestPickType.Under)}
                disabled={disableBtn || !canPick}
                className={`arrowButton down ${disableBtn ? 'disabled' : ''} ${parlay.isContestPickSelected(contest.Id, ContestPickType.Under) ? 'selected gold-background' : ''}`}
            >
                <i className={'fa-solid fa-arrow-down'}/>
            </button>}
            {showRemoveButton && <a className="removeButton"
                                    onClick={() => handleRemoveClick()}></a>}
            {renderPickStatusIcon()}
        </div>
    );
}

export default ContestPickStatus;